export const AddingUpsellsSkippedEvent = 'AddingUpsellsSkipped';

export const UpsellsUpdatedEvent = 'UpsellsUpdated';

export const UpsellType = {
  required: 0,
  optional: 1,
};
